/**
 * Kiritishni tozalash va ko'rinishga keltirish.
 *
 * Maydonlar «o'zi tuzatadi»: sotuvchi qanday yozsa ham, backendga toza
 * qiymat ketadi. Shu sababli formatlash bitta joyda — ikkita ekranда
 * ikki xil bo'lib qolmasin.
 */

/** `8600123456783456` → `8600 1234 5678 3456`. */
export function formatPan(digits: string): string {
  return (digits.slice(0, 16).match(/.{1,4}/g) ?? []).join(' ');
}

/** 4 ta raqam → `12/30`. Backendga baribir 4 ta raqam ketadi. */
export function formatExpiry(digits: string): string {
  const d = digits.slice(0, 4);
  return d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d;
}

/** `998901234567` → `998 90 123 45 67`. */
export function formatPhone(digits: string): string {
  const d = digits.slice(0, 12);
  return [d.slice(0, 3), d.slice(3, 5), d.slice(5, 8), d.slice(8, 10), d.slice(10, 12)]
    .filter(Boolean)
    .join(' ');
}

/**
 * Ko'rinishi lotinchaga o'xshash kirill harflari.
 *
 * Pasport seriyasi hujjatda lotincha (AA1234567), lekin klaviatura ko'pincha
 * ruscha bo'ladi va sotuvchi «АВ» deb yozib qo'yadi — ko'zga bir xil, qiymati
 * boshqa, backend esa rad etadi. Shuning uchun o'xshashlarini o'zimiz
 * almashtiramiz.
 */
const CYRILLIC_TO_LATIN: Record<string, string> = {
  А: 'A', В: 'B', Е: 'E', К: 'K', М: 'M', Н: 'H', О: 'O',
  Р: 'P', С: 'C', Т: 'T', У: 'Y', Х: 'X', І: 'I', Ё: 'E',
};

/**
 * Pasport: 2 ta lotin harfi + 7 ta raqam.
 * Mos kelmaydigan belgi (masalan, «Ф» yoki probel) umuman qabul qilinmaydi.
 */
export function normalizePassport(input: string): string {
  let out = '';
  for (const char of input.toUpperCase()) {
    const ch = CYRILLIC_TO_LATIN[char] ?? char;
    if (out.length < 2) {
      if (/[A-Z]/.test(ch)) out += ch;
    } else if (out.length < 9) {
      if (/\d/.test(ch)) out += ch;
    }
  }
  return out;
}

/**
 * `1994-03-21` → `21.03.1994`.
 *
 * Kartochkadagi sana kiritish maydonidagi bilan bir xil ko'rinishda
 * bo'lishi kerak — ikki xil format bir ekranda chalkashtiradi.
 */
export function formatIsoDate(iso: string | null): string {
  const m = iso ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso) : null;
  return m ? `${m[3]}.${m[2]}.${m[1]}` : (iso ?? '');
}


/**
 * Vaqt belgisidan sana: `dd.mm.yyyy`.
 *
 * Brauzerning `toLocaleDateString` i tilga qarab har xil yozadi
 * (`8/24/2026`, `2026-08-24`) — bir ekranda ikki xil format
 * chalkashtiradi. Butun tizimda bitta ko'rinish.
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

/** Soat va daqiqa — sana yonida ko'rsatish uchun. */
export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
